import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertsPanel = ({ events, onSendSMS, smsEnabled = false }) => {
  if (!events || events?.length === 0) {
    return (
      <div className="card bg-success/5 border-success/20 mt-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="CheckCircle" size={24} className="text-success" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground">All Systems Operational</h3>
            <p className="text-sm text-muted-foreground">No critical alerts at this time</p>
          </div>
        </div>
      </div>
    );
  }

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const eventTime = new Date(timestamp);
    const diffMs = now - eventTime;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    return `${diffHours}h ago`;
  };

  return (
    <div className="card bg-error/5 border-error/20 mt-6">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-error/10 flex items-center justify-center flex-shrink-0">
          <Icon name="AlertTriangle" size={24} className="text-error" />
        </div>
        
        <div className="flex-1">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-base font-semibold text-foreground">Critical Alerts</h3>
            <span className="px-2 py-1 text-xs font-medium rounded-full bg-error/10 text-error">
              {events?.length} {events?.length === 1 ? 'alert' : 'alerts'}
            </span>
          </div>
          
          <div className="space-y-3">
            {events?.slice(0, 3)?.map((event) => (
              <div 
                key={event?.id}
                className="flex items-start gap-3 p-3 rounded-lg bg-background border border-border hover:shadow-md transition-all"
              >
                <Icon name={event?.icon} size={20} className="text-error flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <p className="text-sm font-medium text-foreground">{event?.title}</p>
                    <span className="text-xs text-muted-foreground whitespace-nowrap">
                      {getTimeAgo(event?.timestamp)}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">{event?.description}</p>
                </div>
                <button className="px-3 py-1 text-xs font-medium rounded-lg bg-error text-white hover:bg-error/90 transition-colors focus-ring flex-shrink-0">
                  Resolve
                </button>
                {smsEnabled && (
                  <button 
                    onClick={() => onSendSMS?.(event)}
                    className="px-3 py-1 text-xs font-medium rounded-lg bg-primary text-white hover:bg-primary/90 transition-colors focus-ring flex-shrink-0 flex items-center gap-1"
                    title="Send SMS Alert"
                  >
                    <Icon name="MessageSquare" size={14} />
                    SMS
                  </button>
                )}
              </div>
            ))}
          </div>
          
          {events?.length > 3 && (
            <button className="mt-3 text-sm text-primary hover:text-primary/80 transition-colors font-medium">
              View all {events?.length} alerts →
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertsPanel;